import { Actions, createNamespace } from "../../../flux/Actions";

const ns = createNamespace('VALUE');
export const names = {
    SET: ns('SET'),
    CLEAR: ns('CLEAR'),
};

export class ValueActions<T> extends Actions
{
    set = <T>(value: T, dispatchToken: string) => this.dispatch(names.SET, value, dispatchToken);
    clear = (dispatchToken: string) => this.dispatch(names.CLEAR, null, dispatchToken);
}


// WEBPACK FOOTER //
// ./src/app/flux/Value/ValueActions.ts